<template>
    <div class="float-right" v-if="$temAcessoView('CTRLACS-APP-01')">
        <b-button
            variant="primary"
            @click.stop="$router.push({ name: 'Aplicacoes_Inserir' })"
        >
            <span> <i class="fa fa-plus mr-2"></i> Inserir Aplicação</span>
        </b-button>
    </div>
</template>

<script>
export default {}
</script>
